const labelMatch =
  /([^?@]|^)\b((p?q)(\d+[:-]\d+|(\d+\.)+\d+|(\d+,)+\d+|\d+)([a-z]+(\d+[:-]\d+|(\d+\.)+\d+|(\d+,)+\d+|\d+))*([a-z])*)\b/gi
export const errorLabelMatch =
  /(\?\b(p?q)(\d+[:-]\d+|(\d+\.)+\d+|(\d+,)+\d+|\d+)([a-z]+(\d+[:-]\d+|(\d+\.)+\d+|(\d+,)+\d+|\d+))*([a-z])*)\b/gi
export default labelMatch
